import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AcquinPopup.module.css";

// All three language titles to be displayed together
const titles = {
  uz: "ACQUIN tomonidan institutsional akkreditatsiyadan o'tgan",
  en: "Institutionally accredited by ACQUIN",
  ru: "Институционально аккредитован организацией ACQUIN",
};

export const AcquinPopup = () => {
  // i18n is kept for potential future use, but we show all languages regardless of current language
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  // Auto‑close after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => setIsClosing(true), 5000);
    const hideTimer = setTimeout(() => setIsOpen(false), 5300);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!isOpen) return null;

  return (
    <div
      className={`${styles.overlay} ${isClosing ? styles.fadeOut : styles.fadeIn}`}
      onClick={() => setIsClosing(true)}
    >
      <div
        className={`${styles.modalContainer} ${isClosing ? styles.scaleDown : styles.scaleUp}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className={styles.closeBtn}
          onClick={() => setIsClosing(true)}
          aria-label="Close"
        >
          &times;
        </button>

        <div className={styles.progressBarContainer}>
          <div className={styles.progressBar} />
        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.logoWrapper}>
            <img
              src={`${process.env.PUBLIC_URL || ""}/logo-acquin.png`}
              alt="ACQUIN Logo"
              className={styles.logo}
            />
          </div>
          {/* Render each language title */}
          {Object.entries(titles).map(([lang, txt]) => (
            <h3 key={lang} className={styles.title}>
              {txt}
            </h3>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AcquinPopup;
